import React from 'react'

import {
  LoveIcon,
  LikeIcon,
  MehIcon,
  NopeIcon,
  SkipIcon,
} from 'src/components/Icons'
import { ActionAnswer } from 'src/api/quizzes/types'

interface Props {
  answer: ActionAnswer
}
export const AnswerEmotion: React.FC<Props> = ({ answer }) => {
  switch (answer) {
    case ActionAnswer.up:
      return <LoveIcon size={40} />
    case ActionAnswer.right:
      return <LikeIcon size={40} />
    case ActionAnswer.left:
      return <MehIcon size={40} />
    case ActionAnswer.down:
      return <NopeIcon size={40} />
    case ActionAnswer.skip:
      return <SkipIcon size={40} />
    default:
      return null
  }
}
